jQuery( $ => {
	/**
	 * Make sure anchor tags with just a # as href attribute value is disabled.
	 *
	 * not cmplz-link is to make sure the Complianz doc links works,
	 * sine they are replaced by javascript and there for still
	 * has a href of # in source
	 */
	$( 'a[href="#"]' ).not( '.cmplz-link' ).click( e => {
		// Check if it is still '#' by the time this is executed.
		if ( '#' !== e.currentTarget.getAttribute( 'href' ) ) {
			return;
		}

		e.preventDefault();
	} );

	/**
	 * Trigger the scrollOffset function on inpage anchor links.
	 */
	$( 'a[href^="#"]:not([href="#"])' ).click( function( e ) {
		const el = $( this );
		const target = $( el.attr( 'href' ) );

		// Bail if we can't find the target on this page.
		if ( ! target || 0 === target.length ) {
			return;
		}
		// Prevent default behaviour
		e.preventDefault();
		// Add the anchor link to the URL without triggering any scrolls.
		history.replaceState( {}, '', this.href ); // eslint-disable-line no-undef
		// Call the function and request animation!
		handleScrollOffset( target, true );
	} );

	/**
	 * Trigger custom location scroll on page load.
	 */
	if ( location.hash ) { // eslint-disable-line no-undef
		handleOnloadScroll( location.hash ); // eslint-disable-line no-undef
	}

	/**
	 * Handle scroll position on page load with an hash.
	 *
	 * @param {string} hash the url hash which should correspond to the ID of an element.
	 */
	function handleOnloadScroll( hash ) {
		const target = $( hash );

		// Bail if we can't find the target on this page.
		if ( ! target || 0 === target.length ) {
			return;
		}

		// Delay this by just a millisecond and we hit our actual target.
		// This is a hack to get the position right after the browsers own scroll.
		setTimeout( function() {
			handleScrollOffset( target );
		}, 1 );
	}

	/**
	 * Make sure we offset the scroll position by the headers height.
	 *
	 * @param {string}  target  the target elements ID attribute.
	 * @param {boolean} animate wether to animate the scroll or not.
	 */
	function handleScrollOffset( target, animate = false ) {
		// Get standard offset.
		let offTop = target.offset().top;

		// Check if menu is sticky
		const menu = $( '.site-header' );
		if ( menu.is( '.is-sticky' ) || 'sticky' === menu.css( 'position' ) || 'fixed' === menu.css( 'position' ) ) {
			// Calculate offset with menu height.
			offTop -= ( menu.outerHeight() );
		}

		// Animate to the scroll position if requested.
		if ( animate ) {
			$( 'html, body' ).animate(
				{ scrollTop: offTop },
				200
			);
			return;
		}

		// Move the scroll position in place without animation!
		$( window ).scrollTop( offTop );
	}
} );
